import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-top">
        <div>
          <img
            src="https://cdn-icons-png.flaticon.com/512/1692/1692037.png"
            alt=""
          />
          <p>
            Find a Store <br />
            Choose a Store
          </p>
        </div>
        <div>
          <img
            src="https://cdn-icons-png.flaticon.com/512/9670/9670815.png"
            alt=""
          />
          <p>
            Live beauty help <br />
            Chat to us 24/7
          </p>
        </div>
        <div>
          <img
            src="https://cdn-icons-png.flaticon.com/512/1091/1091669.png"
            alt=""
          />
          <p>
            Get the app <br />
            Download Now
          </p>
        </div>
        <div>
          <img
            src="https://cdn-icons-png.flaticon.com/512/1180/1180304.png"
            alt=""
          />
          <p>
            Get Sephore Text Alerts <br />
            Sign up Now
          </p>
        </div>
        <div>
          <img
            src="https://cdn-icons-png.flaticon.com/512/1198/1198299.png"
            alt=""
          />
          <p>
            Sephora Credit Card Program <br />
            Get Discounts
          </p>
        </div>
      </div>
      <div className="footer-middle">
        <div>
          <h5>About Sephora</h5>
          <p>About Sephora</p>
          <p>Newsroom</p>
          <p>Careers</p>
          <p>Sephora Values</p>
          <p>Supply Chain Transparency</p>
          <p>Affiliates</p>
          <p>Sephora Events</p>
          <p>Gift Cards</p>
          <p>Sephora Global Sites</p>
          <p>Diversity, Equity & Inclusion</p>
          <p>Checkout on Instagram</p>
          <p>Sephora Accelerate</p>
          <p>Report a Vulnerability</p>
        </div>
        <div>
          <h5>My Sephora</h5>
          <p>Beauty Insider</p>
          <p>Sephora Credit Card</p>
          <p>Community Profile</p>
          <p>Order Status</p>
          <p>Purchase History</p>
          <p>Account Setting</p>
          <p>Beauty Advisor Recommendationm</p>
          <p>Beauty Offerse</p>
          <p>Quizzes & Buying Guides</p>
          <p>Rewards Bazaar</p>
          <p>Loves</p>
          <p>Book Reservation</p>
        </div>
        <div>
          <h5>Help</h5>
          <p>Customer Service</p>
          <p>Returns & Exchanges</p>
          <p>Delivery & Pickup Options</p>
          <p>Shipping</p>
          <p>Billing</p>
          <p>International Shipping</p>
          <p>Beauty Services FAQ</p>
          <p>Sephora at Kohl's</p>
          <p>Store Locations</p>
          <p>Online Ordering</p>
          <p>Klarna & Afterpay</p>
          <p>Accessibility</p>
        </div>
        <div>
          <h5>Region & Language</h5>
          <p>United States - English</p>
          <p>Canada - English</p>
          <p>Canada - Français</p>
        </div>
        <div className="input-div">
          <div>
            <h2>
              We Belong to <br /> Something Beautiful
            </h2>
          </div>
          <div>
            <div className="mail-div">
              <p>Sign up for Sephora Emails</p>
              <input
                type="email"
                placeholder="Enter your email address"
                id=""
              />
              <button>Sign Up</button>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-end">
        <div>
          <p>© 2023 Sephora USA, Inc. All rights reserved.</p>
          <p>
            Privacy Policy Terms of Use Accessibility Sitemap Your Privacy
            Choices
          </p>
          <p>1-877-737-4672 TTY: 1-888-866-9845</p>
        </div>
        <div className="social-icons">
          <img
            src="https://cdn-icons-png.flaticon.com/512/4138/4138124.png"
            alt=""
          />
          <img
            src="https://cdn-icons-png.flaticon.com/512/733/733547.png"
            alt=""
          />
          <img
            src="https://cdn-icons-png.flaticon.com/512/2504/2504947.png"
            alt=""
          />
          <img
            src="https://cdn-icons-png.flaticon.com/512/3670/3670147.png"
            alt=""
          />
          <img
            src="https://cdn-icons-png.flaticon.com/512/145/145808.png"
            alt=""
          />
          <img
            src="https://cdn-icons-png.flaticon.com/512/3669/3669965.png"
            alt=""
          />
          <img
            src="https://cdn-icons-png.flaticon.com/512/3938/3938055.png"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};


export default Footer;
